import CryptoJS from 'crypto-js';

// ✅ FIX: Backend (appsettings.json) की exact key यहाँ लगा दी गई है
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'Msspl@2024-CSA-Secret-Key-32Byte';

export const encryptData = (data: any): string => {
  try {
    const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonString, ENCRYPTION_KEY).toString();
    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error);
    throw new Error('Failed to encrypt data');
  }
};

export const decryptData = (encryptedData: string): any => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    
    if (!decrypted) {
      throw new Error('Failed to decrypt data - invalid key or data');
    }
    
    try {
      return JSON.parse(decrypted);
    } catch {
      return decrypted;
    }
  } catch (error) {
    console.error('Decryption error:', error);
    throw new Error('Failed to decrypt data');
  }
};

// Secure localStorage functions
export const secureSetItem = (key: string, data: any): void => {
  try {
    const encryptedData = encryptData(data);
    localStorage.setItem(key, encryptedData);
  } catch (error) {
    console.error('Error setting secure item:', error);
  }
};

export const secureGetItem = (key: string): any => {
  try {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;
    
    return decryptData(encryptedData);
  } catch (error) {
    console.error('Error getting secure item:', error);
    return null;
  }
};

export const secureSessionSetItem = (key: string, data: any): void => {
  try {
    const encryptedData = encryptData(data);
    sessionStorage.setItem(key, encryptedData);
  } catch (error) {
    console.error('Error setting secure session item:', error);
  }
};

export const secureSessionGetItem = (key: string): any => {
  try {
    const encryptedData = sessionStorage.getItem(key);
    if (!encryptedData) return null;
    
    return decryptData(encryptedData);
  } catch (error) {
    console.error('Error getting secure session item:', error);
    return null;
  }
};

export const secureRemoveItem = (key: string): void => {
  localStorage.removeItem(key);
};